<template>
  <div v-if="!loading">
    <p class="xPadding titleModal">
      {{ $t(`technicalFile.SoftPolisherDealk.systemSpecification`) }}
    </p>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        cols="12"
      >
        <VTextField
          v-model="form.systemSpecification.identifier"
          class="text-field-transparent"
          :label="$t('technicalFile.feedWaterOrDeaerator.identifier')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>

    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VSelect
          v-model="form.systemSpecification.type"
          :items="displayedTypes"
          class="text-field-transparent"
          :label="$t('technicalFile.feedWaterOrDeaerator.type')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>

    <div v-if="form.systemSpecification.type === 'hotwell'">
      <v-row
        class="xPadding"
      >
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VSelect
            v-model="form.systemSpecification.hotwell.steamInjection"
            :items="displayedYesOrNot"
            :label="$t('technicalFile.feedWaterOrDeaerator.steamInjection')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row class="xPadding">
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VTextField
            v-model="form.systemSpecification.hotwell.temperatureMaintained.value"
            class="text-field-transparent"
            :label="$t('technicalFile.feedWaterOrDeaerator.temperatureMaintened')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VSelect
            v-model="form.systemSpecification.hotwell.temperatureMaintained.unit"
            :items="displayedTemperature"
            class="text-field-transparent"
            :label="$t('technicalFile.SoftPolisherDealk.unite')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
    </div>

    <div v-if="form.systemSpecification.type === 'deaerator'">
      <v-row
        class="xPadding"
      >
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VSelect
            v-model="form.systemSpecification.deaerator.type"
            :items="displayedDeaeratorType"
            class="text-field-transparent"
            :label="$t('technicalFile.feedWaterOrDeaerator.type')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row class="xPadding">
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VTextField
            v-model="form.systemSpecification.deaerator.pressure.value"
            class="text-field-transparent"
            :label="$t('technicalFile.feedWaterOrDeaerator.pressure')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VSelect
            v-model="form.systemSpecification.deaerator.pressure.unit"
            :items="displayUnitPressure"
            class="text-field-transparent"
            :label="$t('technicalFile.SoftPolisherDealk.unite')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row class="xPadding">
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VTextField
            v-model="form.systemSpecification.deaerator.temperature.value"
            class="text-field-transparent"
            :label="$t('technicalFile.feedWaterOrDeaerator.temperature')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VSelect
            v-model="form.systemSpecification.deaerator.temperature.unit"
            :items="displayedTemperature"
            class="text-field-transparent"
            :label="$t('technicalFile.SoftPolisherDealk.unite')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
    </div>

    <div v-if="form.systemSpecification.type === 'vacuum'">
      <v-row class="xPadding">
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VSelect
            v-model="form.systemSpecification.vacuum.type"
            :items="displayedDeaeratorType"
            class="text-field-transparent"
            :label="$t('technicalFile.feedWaterOrDeaerator.type')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row class="xPadding">
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VTextField
            v-model="form.systemSpecification.vacuum.pressure.value"
            class="text-field-transparent"
            :label="$t('technicalFile.feedWaterOrDeaerator.pressure')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VSelect
            v-model="form.systemSpecification.vacuum.pressure.unit"
            :items="displayUnitPressure"
            class="text-field-transparent"
            :label="$t('technicalFile.SoftPolisherDealk.unite')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
      <v-row class="xPadding">
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VTextField
            v-model="form.systemSpecification.vacuum.temperature.value"
            class="text-field-transparent"
            :label="$t('technicalFile.feedWaterOrDeaerator.temperature')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
        <v-col
          class="py-0"
          md="6"
          sm="12"
        >
          <VSelect
            v-model="form.systemSpecification.vacuum.temperature.unit"
            :items="displayedTemperature"
            class="text-field-transparent"
            :label="$t('technicalFile.SoftPolisherDealk.unite')"
            outlined
            :readonly="readonly"
            flat
            @input="updateData"
          />
        </v-col>
      </v-row>
    </div>

    <p class="xPadding titleModal">
      {{ $t(`technicalFile.feedWaterOrDeaerator.metallurgy`) }}
    </p>

    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VSelect
          v-model="form.metallurgy.type"
          :items="displayMetalurgyTypes"
          class="text-field-transparent"
          :label="$t('technicalFile.feedWaterOrDeaerator.type')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        v-if="form.metallurgy.type === 'other'"
        class="py-0"
        md="6"
        sm="12"
      >
        <VTextField
          v-model="form.metallurgy.otherOption"
          class="text-field-transparent"
          :label="$t('technicalFile.feedWaterOrDeaerator.other')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VTextField
          v-model="form.metallurgy.volumeDuringOperation.value"
          class="text-field-transparent"
          :label="$t('technicalFile.feedWaterOrDeaerator.volumeDuringOperation')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VSelect
          v-model="form.metallurgy.volumeDuringOperation.unit"
          :items="displayedVolumeDuringOperation"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.unite')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <p class="xPadding titleModal">
      {{ $t('technicalFile.feedWaterOrDeaerator.feedWaterPumps') }}
    </p>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VTextField
          v-model="form.feedWaterPumps.numberOfPumps"
          class="text-field-transparent"
          :label="$t('technicalFile.feedWaterOrDeaerator.numberOfPumps')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
      <v-col
        class="py-0"
        md="6"
        sm="12"
      >
        <VSelect
          v-model="form.feedWaterPumps.operatingPrinciple"
          :items="displayedOperatingPrinciple"
          class="text-field-transparent"
          :label="$t('technicalFile.SoftPolisherDealk.type')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>

    <p class="xPadding titleModal">
      {{ $t('technicalFile.feedWaterOrDeaerator.feedWaterPumps') }}
    </p>
    <v-row class="xPadding">
      <v-col
        class="py-0"
        cols="12"
      >
        <VTextField
          v-model="form.otherComments"
          class="text-field-transparent"
          :label="$t('technicalFile.feedWaterOrDeaerator.otherComments')"
          outlined
          :readonly="readonly"
          flat
          @input="updateData"
        />
      </v-col>
    </v-row>
    <div>
      <VTableHistory
        :headers="headers"
        :items="itemsForHistory"
      />
    </div>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VTableHistory from '@/components/shared/content-views/VTableHistory';
import { mapGetters } from 'vuex';
import _datePickerLocales from '@/locales/date-picker-locales';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect';
import lockService from '@/utilities/lockService';
import { isEmpty } from 'lodash';

export default {
    name: 'FeedWaterDeaerator',
    components: {
        VTextField,
        VTableHistory,
        VSelect,
    },
    props: {
        system: {
            type: Object,
            default: () => {},
        },
        parentNode: {
            type: String,
            default: () => '',
        },
        node: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
            form: {
                systemSpecification: {
                    identifier: null,
                    type: null,
                    hotwell: {
                        steamInjection: null,
                        temperatureMaintained: {
                            value: null,
                            unit: null,
                        },
                    },
                    deaerator: {
                        type: null,
                        pressure: {
                            value: null,
                            unit: null,
                        },
                        temperature: {
                            value: null,
                            unit: null,
                        },
                    },
                    vacuum: {
                        type: undefined,
                        pressure: {
                            value: undefined,
                            unit: undefined,
                        },
                        temperature: {
                            value: undefined,
                            unit: undefined,
                        },
                    },
                },
                metallurgy: {
                    type: null,
                    otherOption: null,
                    volumeDuringOperation: {
                        value: null,
                        unit: null,
                    },
                },
                feedWaterPumps: {
                    numberOfPumps: null,
                    operatingPrinciple: null,
                },
                otherComments: null,
                history: [],
            },
            multipleChoices: {
                type: ['deaerator', 'hotwell', 'vacuum'],
                unitTemperature: ['C', 'F'],
                unitPressure: ['psi', 'kpa'],
                yesOrNot: ['yes', 'no'],
                deaeratorType: ['spray', 'spray-tray', 'tray', 'other'],
                metallurgyTypes: ['mildSteel', 'stainlessSteel', 'other'],
                volumeDuringOperation: ['liters', 'm3', 'usg', 'impgal'],
                operatingPrinciple: ['continuous', 'intermittent', 'other'],
            },
        };
    },

    computed: {
        ...mapGetters([
            'activeTab',
            'site',
            'userLang',
            'hasPermission',
        ]),
        readonly() {
            return !this.hasPermission('techFiles.edit');
        },
        headers() {
            return [
                'updatedAt',
                'updatedBy',
                'action',
            ].map(header => ({
                text: this.$t(`forms.history.${header}`),
                value: header,
            }));
        },
        datePickerLocales() {
            return _datePickerLocales;
        },
        itemsForHistory() {
            if (this.form.history) {
                const copyItems = [...this.form.history];
                const copyItemsFormatted = copyItems.map(item => ({
                    updatedBy: `${item.updatedBy.firstName} ${item.updatedBy.lastName}`,
                    action: item.action,
                    updatedAt: this.$options.filters.formatDate(item.updatedAt, 'L LT'),
                }));
                return copyItemsFormatted;
            }
            return [];
        },
        displayedTypes() {
            return this.multipleChoices.type.map(name => ({
                name: this.$t(`technicalFile.feedWaterOrDeaerator.${name}`),
                id: name,
            }));
        },

        displayedYesOrNot() {
            return this.multipleChoices.yesOrNot.map(name => ({
                name: this.$t(`technicalFile.feedWaterOrDeaerator.${name}`),
                id: name === 'yes',
            }));
        },
        displayedDeaeratorType() {
            return this.multipleChoices.deaeratorType.map(name => ({
                name: this.$t(`technicalFile.feedWaterOrDeaerator.${name}`),
                id: name,
            }));
        },
        displayUnitPressure() {
            return this.multipleChoices.unitPressure.map(name => ({
                name: this.$t(`technicalFile.feedWaterOrDeaerator.${name}`),
                id: name,
            }));
        },
        displayMetalurgyTypes() {
            return this.multipleChoices.metallurgyTypes.map(name => ({
                name: this.$t(`technicalFile.feedWaterOrDeaerator.${name}`),
                id: name,
            }));
        },
        displayedOperatingPrinciple() {
            return this.multipleChoices.operatingPrinciple.map(name => ({
                name: this.$t(`technicalFile.feedWaterOrDeaerator.${name}`),
                id: name,
            }));
        },
        displayedVolumeDuringOperation() {
            return this.multipleChoices.volumeDuringOperation.map(name => ({
                name: this.$t(`technicalFile.feedWaterOrDeaerator.${name}`),
                id: name,
            }));
        },
        displayedTemperature() {
            return this.multipleChoices.unitTemperature.map(name => ({
                name: this.$t(`technicalFile.feedWaterOrDeaerator.${name}`),
                id: name,
            }));
        },
    },
    async mounted() {
        this.loading = true;
        await this.getTechFile();
        this.loading = false;
        window.addEventListener('beforeunload', this.handleUnload);
    },
    beforeDestroy() {
        if (this.node && this.node.ref) {
            lockService.releaseLock(this.node.ref, 'TechnicalFileFeedWaterDeaerator');
        }
        window.removeEventListener('beforeunload', this.handleUnload);
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.form);
        },
        handleUnload() {
            if (this.node && this.node.ref) {
                lockService.releaseLock(this.node.ref, 'TechnicalFileFeedWaterDeaerator');
            }
        },

        async getTechFile() {
            this.loading = true;
            const techfile = await this.$rq.getNodeInfo(this.site.id, this.node.ref);
            if (!isEmpty(techfile.data)) {
                this.form = { ...this.form, ...techfile.data };
            }
            this.loading = false;
        },
    },
};
</script>
<style lang="scss" scoped>
    .xPadding{
      padding: 0 6rem;
    }
  @media screen and (max-width: 600px) {
    .xPadding{
        padding: 0;
    }
  }
</style>
